import InfoTvStatPage from "pages/InfoTvStatPage";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom"

const AppRouter = () => {

    return (
        <Routes>
            <Route path="/" element={<InfoTvStatPage />} />
            <Route path="*" element={<Navigate to="/nofound" />} />
        </Routes>
    )
}

export default AppRouter